var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstancesDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4028 7.54167H3.59722C2.50757 7.54167 1.625 6.6591 1.625 5.56944V3.59722C1.625 2.50757 2.50757 1.625 3.59722 1.625H17.4028C18.4924 1.625 19.375 2.50757 19.375 3.59722V5.56944C19.375 6.6591 18.4924 7.54167 17.4028 7.54167Z",
    fill: "url(#paint0_linear_68_1192)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4028 13.4584H3.59722C2.50757 13.4584 1.625 12.5758 1.625 11.4861V9.51391C1.625 8.42426 2.50757 7.54169 3.59722 7.54169H17.4028C18.4924 7.54169 19.375 8.42426 19.375 9.51391V11.4861C19.375 12.5758 18.4924 13.4584 17.4028 13.4584Z",
    fill: "url(#paint1_linear_68_1192)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4028 19.375H3.59722C2.50757 19.375 1.625 18.4924 1.625 17.4028V15.4305C1.625 14.3409 2.50757 13.4583 3.59722 13.4583H17.4028C18.4924 13.4583 19.375 14.3409 19.375 15.4305V17.4028C19.375 18.4924 18.4924 19.375 17.4028 19.375Z",
    fill: "url(#paint2_linear_68_1192)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4861 5.56945H5.56942C5.0241 5.56945 4.58331 5.12767 4.58331 4.58334C4.58331 4.03901 5.0241 3.59723 5.56942 3.59723H11.4861C12.0314 3.59723 12.4722 4.03901 12.4722 4.58334C12.4722 5.12767 12.0314 5.56945 11.4861 5.56945Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4306 5.56945C15.9752 5.56945 16.4167 5.12795 16.4167 4.58334C16.4167 4.03873 15.9752 3.59723 15.4306 3.59723C14.886 3.59723 14.4445 4.03873 14.4445 4.58334C14.4445 5.12795 14.886 5.56945 15.4306 5.56945Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4861 11.4861H5.56942C5.0241 11.4861 4.58331 11.0444 4.58331 10.5C4.58331 9.95569 5.0241 9.51392 5.56942 9.51392H11.4861C12.0314 9.51392 12.4722 9.95569 12.4722 10.5C12.4722 11.0444 12.0314 11.4861 11.4861 11.4861Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4306 11.4861C15.9752 11.4861 16.4167 11.0446 16.4167 10.5C16.4167 9.95541 15.9752 9.51392 15.4306 9.51392C14.886 9.51392 14.4445 9.95541 14.4445 10.5C14.4445 11.0446 14.886 11.4861 15.4306 11.4861Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4861 17.4028H5.56942C5.0241 17.4028 4.58331 16.961 4.58331 16.4167C4.58331 15.8723 5.0241 15.4305 5.56942 15.4305H11.4861C12.0314 15.4305 12.4722 15.8723 12.4722 16.4167C12.4722 16.961 12.0314 17.4028 11.4861 17.4028Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4306 17.4028C15.9752 17.4028 16.4167 16.9613 16.4167 16.4167C16.4167 15.872 15.9752 15.4305 15.4306 15.4305C14.886 15.4305 14.4445 15.872 14.4445 16.4167C14.4445 16.9613 14.886 17.4028 15.4306 17.4028Z",
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_1192",
    x1: 10.5,
    y1: 1.625,
    x2: 10.5,
    y2: 7.54167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_68_1192",
    x1: 10.5,
    y1: 7.54169,
    x2: 10.5,
    y2: 13.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_68_1192",
    x1: 10.5,
    y1: 13.4583,
    x2: 10.5,
    y2: 19.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787878"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstancesDefault);
export default __webpack_public_path__ + "static/media/instances-default.5c04856c97b5b285114572804d216c57.svg";
export { ForwardRef as ReactComponent };